import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { LanguageSelector } from "@/uiKit/molecules/LanguageSelector.tsx";

export type LanguageProps = {
  className?: string;
};

export const Language: React.FC<LanguageProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Card id="language-selection-card" className={className}>
      <CardHeader id="language-title" title={t("pages.account.language.title")} />
      <CardContent>
        <LanguageSelector id="language-selection-button" className={styles.language} display="full" />
      </CardContent>
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  infoDisplay: css`
    column-gap: ${theme.spacing(12)};
  `,
  language: css({
    width: "fit-content",
  }),
});
